import axios from 'axios';
import { ICheckOsobaOR } from 'types/leiTypes';

const checkOsobaOrApi = (data: ICheckOsobaOR) => {
    return axios({
        method: 'GET',
        url: 'LEI/CheckOsobaOR',
        params: {
            ic: data.ic,
            jmeno: data.jmeno,
            prijmeni: data.prijmeni
        }
    }).then(resp => resp.data);
};

export default checkOsobaOrApi;
